require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./neighborhood-watch-programs.json") })
        }
      }, "path---neighborhood-watch-programs");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---neighborhood-watch-programs!./.cache/json/neighborhood-watch-programs.json
// module id = 941
// module chunks = 231608221292675